<script>
  import { onMount } from "svelte";
  import { Textfield } from "../components";
  import Card, { Content, Actions, ActionIcons } from "@smui/card";
  import IconButton from "@smui/icon-button";
  import AddressSearch from "./AddressSearch.svelte";
  export let data;
  let errorsPassed;
  let isNew = data ? false : true;
  export { errorsPassed as errors };

  let errors = {};

  $: errors = errorsPassed ? errorsPassed : {};

  function add() {
    data = {};
  }

  function setAddress(e) {
    console.log("Got event: ", e);
    if (e.detail) {
      data = e.detail;
    }
  }
</script>

<style>
  .title {
    display: flex;
    justify-content: space-between;
  }
</style>

<Card variant="outlined" padded>
  <span class="title">
    <h3>Address</h3>
    {#if !data}
      <IconButton class="material-icons" on:click={add}>add</IconButton>
    {:else if isNew}
      <IconButton class="material-icons" on:click={() => (data = null)}>
        cancel
      </IconButton>
    {/if}
  </span>
  {#if data}
    <AddressSearch on:complete={setAddress} />
    <Textfield
      bind:value={data.address_line_1}
      error={errors.address_line_1}
      label="Address Line 1" />
    <Textfield
      bind:value={data.address_line_2}
      error={errors.address_line_2}
      label="Address Line 2" />
    <Textfield
      class="short"
      bind:value={data.city}
      error={errors.city}
      label="City" />
    <Textfield
      class="short"
      bind:value={data.post_code}
      error={errors.post_code}
      label="Post Code" />
  {/if}
</Card>
